import {XauditModel} from '../xaudit.model';

export class FeeScheduleDoctorDataModel extends XauditModel {
  DocFeeScheduleID: string;
  FeeScheduleID: string;
  DoctorId: string;
  DoctorName: string;
  Description: string;
  enumDoctorTypeID: string;
  FirstName: string;
  LastName: string;
  Title: string;
  ProviderIDbyInsurance: string;
  isActive: boolean;
  OrganizationID: string;
  default_FeeSch_DoctorId: string;
  isSelected: boolean = true;
}
